import {
  dateOnlyOf,
  formatDateMonthDayYear,
  parseIsoDate,
} from '@/lib/utils/custom-date/custom-date';

/**
 * A request's TOIL day as "Mon-DD-YYYY". `ToilDate` is a date-only value (the picked day at
 * 00:00:00 UTC), so it is read by its date part and never converted to a time zone.
 */
export const formatToilDate = (request: { ToilDate?: string | null }): string =>
  formatDateMonthDayYear(parseIsoDate(dateOnlyOf(request.ToilDate)));
